import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, PRIMARY_OUTLET } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpClient } from '@angular/common/http';
import { AuthService } from 'projects/Shared-Lib/services/auth.service';
import { environment } from '../../environments/environment';
import { DataService } from './data.service';
import { AppService } from '../../Auth/src/app/services/app.service';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SSOAuthGuard {
  jwtService: JwtHelperService;

  constructor(private authService: AuthService, private router: Router) {
    this.jwtService = new JwtHelperService();
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    console.log('[SSOAuthGuard][canActivate]');
    const url: string = state.url;
    try {
      if (!this.isLoggedIn()) {
        const tk = route.queryParams.tk;
        if (tk) {
          localStorage.setItem('tk', tk);
          console.log('[SSOAuthGuard][canActivate] set tk');
          await this.GetToken(tk);
        }
      }
      return this.verifyLogin(url);
    } catch (e) {
      this.redirectToErrorPage(401, 'UnAuthorized', { message: e.message });
    }
  }

  public isLoggedIn(): boolean {
    const token = localStorage.getItem('access_token');
    if (!token) {
      console.log('[SSOAuthGuard][isLoggedIn] Has not logged in yet');
      return false;
    }
    if (this.jwtService.isTokenExpired(token)) console.log('TODO: Refresh Token');
    console.log('[SSOAuthGuard][isLoggedIn] Had logged in');
    return true;
  }

  public async GetToken(tk: string): Promise<void> {
    console.log('[SSOAuthGuard][GetToken]');
    await this.authService.SingleSignOn(tk);
  }

  verifyLogin(url: string): boolean {
    console.log('[SSOAuthGuard][verifyLogin]');
    if (this.isLoggedIn()) return true;
    this.authService.login();
    return false;
  }

  private redirectToErrorPage(statusCode, statusText, error) {
    console.log('[SSOAuthGuard][redirectToErrorPage] error', error);
    const statusTextBase64 = btoa(statusText);
    const messageList = [];
    if (error && error.message) messageList.push(error.message);
    if (error && error.error && error.error.Message) messageList.push(error.error.Message);
    const messages = messageList.join('.');
    const messageBase64 = messages ? btoa(messages) : 'no message';
    const errorUri = `/Error?statusCode=${statusCode}&statusText=${statusTextBase64}&message=${messageBase64}`;
    this.router.navigateByUrl(errorUri);
  }
}

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard {
  Controller = 'User';
  protected BaseUrl = environment.APIBaseUrl;

  jwtService: JwtHelperService;
  constructor(private router: Router, private dataService: DataService, private http: HttpClient, private appService: AppService) {
    this.jwtService = new JwtHelperService();
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    console.log('[PermissionGuard][canActivate]');
    const routeData = this.GetActivatedRouteData(route, 'resource');
    if (routeData && routeData.resource) {
      return this.http.get(`${this.BaseUrl}${this.Controller}/Permission/${routeData.resource}`).pipe(
        map((ret: any) => {
          //2021-08-23 GSSPortal Update. Change return type to BaseResultObj
          if (ret.Success) {
            const data = ret.Result;
            if (routeData.action) {
              let permission = data.filter(x => x.ActionName === routeData.action && x.Enabled === true);
              if (permission && permission.length > 0) {
                if (permission[0].Enabled) {
                  return true;
                } else {
                  this.appService.SetErrMsg('Permission deny');
                  //redirect to home
                  this.router.navigate(['/Forbidden']);
                  return false;
                }
              }
            }
          } else {
            throw ret.Result;
          }
          return false;
        }),
        catchError((err) => {
          throw err;
        })
      );
    } else {
      return true;
    }
  }

  GetActivatedRouteData(activeRouter: ActivatedRouteSnapshot, prop: string) {
    const children: ActivatedRouteSnapshot[] = activeRouter.children;
    if (activeRouter.data.hasOwnProperty(prop)) return activeRouter.data;
    if (children.length === 0) return {};
    for (const child of children) {
      // verify primary route
      if (child.outlet !== PRIMARY_OUTLET) continue;
      console.log('child', child);
      return !child.data.hasOwnProperty(prop) ? this.GetActivatedRouteData(child, prop) : child.data;
    }
  }
}
